// @ts-nocheck
import { FEATURE_PREVIEWS_ERROR, FEATURE_PREVIEWS_LOADING, FEATURE_PREVIEWS_SUCCESS} from "../Type";
import * as Authservices from '../../Services/services';

export const feature_previews = (data) => {
    return (dispatch) => {
        return new Promise((resolve, reject) => {
            dispatch({
                type: FEATURE_PREVIEWS_LOADING,
                data: true
            })
            Authservices.feature_previews(data).then((data) => {
                if (data?.status === 200) {
                    dispatch({
                        type: FEATURE_PREVIEWS_SUCCESS,
                        data: data?.data
                    })
                    return resolve(data?.data);
                }
            }).catch((error) => {
                if (error) {
                    dispatch({
                        type: FEATURE_PREVIEWS_ERROR,
                        data: {message: 'An unexpected error (' + (error.response ? error.response.status : 'Network Error') + ') has occurred and AvSight Support has been notified. Please reload the screen and try again.'}
                    })
                }
                return reject({message: 'An unexpected error (' + (error.response ? error.response.status : 'Network Error') + ') has occurred and AvSight Support has been notified. Please reload the screen and try again.'})
            })
        })
    }
}